/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseTrianglesVOpenIcon16Solid = forwardRef('ArrowCollapseTrianglesVOpenIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m3.78 5.72 3.336-3.336a1.25 1.25 0 0 1 1.768 0L12.22 5.72A.75.75 0 0 1 11.69 7H4.31a.75.75 0 0 1-.53-1.28Z" }),
        React.createElement("path", { d: "m3.78 10.28 3.336 3.336a1.25 1.25 0 0 0 1.768 0l3.336-3.336A.75.75 0 0 0 11.69 9H4.31a.75.75 0 0 0-.53 1.28Z" })));
});
